import { getErrorMessage } from "@/helpers/handleErrorResponse";
import { removeEmptyParams } from "@/helpers/objectHelpers";
import { GetAnalysisHistoryParams } from "@/types/analysisHistory";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const ANALYSIS_HISTORY_PER_PAGE = 25;

export const getAnalysisHistoryApi = async (
  pageNumber: number,
  params?: GetAnalysisHistoryParams
) => {
  try {
    const { data } = await axiosInstance.get("/v1/analysis-history", {
      params: {
        per_page: ANALYSIS_HISTORY_PER_PAGE,
        page: pageNumber,
        ...(params ? removeEmptyParams(params) : {})
      }
    });
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const getAnalysisHistoryDetail = async (id: string) => {
  try {
    const { data } = await axiosInstance.get(`/v1/analysis-history/${id}`);
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const deleteAnalysisHistory = async (id: string) => {
  try {
    const { data } = await axiosInstance.delete(`/v1/analysis/${id}`);
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};
